import { s as y } from "../index.es-XNBESE3P.js";
const g = {
  defaultCurrency: "EUR",
  defaultLocale: "en-US",
  /** @hidden  */
  currencySettings: {}
}, p = {
  EUR: "de-DE",
  GBP: "en-GB",
  USD: "en-US",
  AUD: "en-AU",
  CAD: "en-CA",
  //India, Afghanistan, Bangladesh, Bhutan, Myanmar, Nepal, and Pakistan uses lakhs and crores notation
  INR: "en-IN",
  AFN: "en-IN",
  BDT: "en-IN",
  BTN: "en-IN",
  MMK: "en-IN",
  NPR: "en-IN",
  PKR: "en-IN"
};
function d(u = {}) {
  const i = {
    ...g,
    ...u
  };
  u.currencySettings || y((t) => {
    i.currencySettings = t.internal.getSettings().currencySettings ?? {};
  });
  function s(t, e) {
    const { defaultCurrency: n, currencySettings: r, defaultLocale: o } = i, a = e ?? n, f = p[a] ?? o;
    if (a in r) {
      const c = r[a], l = new Intl.NumberFormat(f, {
        useGrouping: !!c.groupingSeparator,
        minimumFractionDigits: c.decimalPlaces,
        maximumFractionDigits: c.decimalPlaces
      }).formatToParts(t).map((m) => m.type === "group" ? c.groupingSeparator : m.type === "decimal" ? c.decimalCharacter : m.value).join("");
      return c?.currencyBeforeAmount ? `${c.currencyToken}${l}` : `${l}${c?.currencyToken}`;
    }
    return new Intl.NumberFormat(f, {
      style: "currency",
      currency: a
    }).format(t);
  }
  return {
    formatCurrency: s
  };
}
function S(u) {
  const { formatCurrency: i } = d(u);
  function s(e, n) {
    const r = {};
    return e.price !== void 0 && (r.priceText = i(e.price, n)), e.listPrice !== void 0 && (r.listPriceText = i(e.listPrice, n)), Object.assign({}, e, r);
  }
  function t(e) {
    return e.price !== void 0 || e.listPrice !== void 0;
  }
  return function(n) {
    if (!t(n))
      return n;
    const r = s(n, n.priceCurrencyCode);
    return r.skus && r.skus.some(t) && (r.skus = r.skus.map((o) => t(o) ? s(o, n.priceCurrencyCode) : o)), r;
  };
}
export {
  d as getCurrencyFormatting,
  S as priceDecorator
};
